import { rem } from '@mantine/core';
import { ComponentPropsWithoutRef, useId } from 'react';

interface EnFlagIconProps extends ComponentPropsWithoutRef<'svg'> {
  size?: number | string;
}

export const EnFlagIcon = (props: EnFlagIconProps) => {
  const maskId = useId();

  return (
    <svg
      aria-label="Great Britain's flag"
      className={props.className}
      style={{
        width: props.size ? rem(props.size) : '100%',
        height: props.size ? rem(props.size) : '100%',
        ...props.style,
      }}
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id={maskId}>
        <circle cx="256" cy="256" fill="#fff" r="256" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="m0 0 8 22-8 23v23l32 54-32 54v32l32 48-32 48v32l32 54-32 54v68l22-8 23 8h23l54-32 54 32h32l48-32 48 32h32l54-32 54 32h68l-8-22 8-23v-23l-32-54 32-54v-32l-32-48 32-48v-32l-32-54 32-54V0l-22 8-23-8h-23l-54 32-54-32h-32l-48 32-48-32h-32l-54 32L68 0H0z"
          fill="#eee"
        />
        <path
          d="M336 0v108L444 0Zm176 68L404 176h108zM0 176h108L0 68ZM68 0l108 108V0Zm108 512V404L68 512ZM0 444l108-108H0Zm512-108H404l108 108Zm-68 176L336 404v108z"
          fill="#0052b4"
        />
        <path
          d="M0 0v45l131 131h45L0 0zm208 0v208H0v96h208v208h96V304h208v-96H304V0h-96zm259 0L336 131v45L512 0h-45zM176 336 0 512h45l131-131v-45zm160 0 176 176v-45L381 336h-45z"
          fill="#d80027"
        />
      </g>
    </svg>
  );
};

export default EnFlagIcon;
